/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { CEFR_LEVELS } from '@repo/config';
import { z } from 'zod';

export { CEFR_LEVELS };

export const cefrLevelSchema = z.enum(CEFR_LEVELS);

export type ICEFRLevel = z.infer<typeof cefrLevelSchema>;
